import BigNum from "../model/math/BigNum";
import GameNumberFormat from "./GameNumberFormat";

/**
 * @constant
 * @type {GameNumberFormat}
 */
const gameNumberFormat = new GameNumberFormat();

export default class NumberFormatter {
    constructor() {        
    }
    
    /**
     * @param {BigNum} bigNum 
     * @returns {string}
     */
    static formatBigNum(bigNum) {
        if (typeof bigNum === "number") {
            console.log('NumberFormatter.formatBigNum() passed number instead of BigNum');
            console.trace();
        }

        if (!bigNum) {
            return '0';
        }

        return gameNumberFormat.formatBigNum(bigNum);
    }

    /**
     * @param {number} i 
     * @returns {string}
     */
    static formatNumber(i) {
        if (i instanceof BigNum) {
            console.log('NumberFormatter.formatNumber() passed BigNum instead of number');
            console.trace();
        }

        return gameNumberFormat.formatNumber(i);
    }

    // /**
    //  * @param {number} i 
    //  * @returns {string}
    //  */
    // static formatNumberFractionAsPercent(i) {
    //   if (i instanceof BigNum) {
    //       console.log('NumberFormatter.formatNumber() passed BigNum instead of number');
    //       console.trace();
    //   }

    //   // 1.2 = 20%
    //   // 1.9 = 90%
    //   // 2.1 = 110%
    //   const val = (i - 1) * 100;

    //   return gameNumberFormat.formatNumber(val) + '%';
    // }

}